"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
const metadata = {
    models: {
        user: {
            name: 'User', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, uid: {
                    name: "uid",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@unique", "args": [] }],
                }, email: {
                    name: "email",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@unique", "args": [] }, { "name": "@allow", "args": [{ "value": "all" }] }],
                }, name: {
                    name: "name",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "name" }] }, { "name": "@allow", "args": [{ "value": "all" }] }],
                }, emailVerified: {
                    name: "emailVerified",
                    type: "DateTime",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "email_verified" }] }, { "name": "@omit", "args": [] }],
                }, profileCompletedAt: {
                    name: "profileCompletedAt",
                    type: "DateTime",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "profile_completed_at" }] }],
                }, image: {
                    name: "image",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "image" }] }],
                }, displayName: {
                    name: "displayName",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "display_name" }] }],
                }, aboutMe: {
                    name: "aboutMe",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "about_me" }] }],
                }, location: {
                    name: "location",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "location" }] }],
                }, url: {
                    name: "url",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "url" }] }],
                }, ikuraplus: {
                    name: "ikuraplus",
                    type: "Boolean",
                    attributes: [{ "name": "@default", "args": [{ "value": false }] }],
                }, ikuraplusStartedAt: {
                    name: "ikuraplusStartedAt",
                    type: "DateTime",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "ikuraplus_started_at" }] }],
                }, isAdmin: {
                    name: "isAdmin",
                    type: "Boolean",
                    attributes: [{ "name": "@default", "args": [{ "value": false }] }, { "name": "@map", "args": [{ "value": "is_admin" }] }],
                }, verifiedOwner: {
                    name: "verifiedOwner",
                    type: "Boolean",
                    attributes: [{ "name": "@default", "args": [{ "value": false }] }, { "name": "@map", "args": [{ "value": "verified_owner" }] }],
                }, businessTags: {
                    name: "businessTags",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "value": "" }] }, { "name": "@map", "args": [{ "value": "business_tags" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                }, lists: {
                    name: "lists",
                    type: "List",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, spots: {
                    name: "spots",
                    type: "Spot",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, trips: {
                    name: "trips",
                    type: "Trip",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, sharedLists: {
                    name: "sharedLists",
                    type: "SharedUsersOnLists",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, followingLists: {
                    name: "followingLists",
                    type: "FollowersOnLists",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, collaboratingLists: {
                    name: "collaboratingLists",
                    type: "CollaboratorsOnLists",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, favedSpots: {
                    name: "favedSpots",
                    type: "UserSpotFav",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, savedPlaces: {
                    name: "savedPlaces",
                    type: "UserPlaceSave",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, visitedSpots: {
                    name: "visitedSpots",
                    type: "UserSpotVisit",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, inquiries: {
                    name: "inquiries",
                    type: "Inquiry",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, accounts: {
                    name: "accounts",
                    type: "Account",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, sessions: {
                    name: "sessions",
                    type: "Session",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, bookingExperiences: {
                    name: "bookingExperiences",
                    type: "BookingExperience",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, saves: {
                    name: "saves",
                    type: "Save",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, uid: {
                    name: "uid",
                    fields: ["uid"]
                }, email: {
                    name: "email",
                    fields: ["email"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "create,read" }, { "value": true }] }, { "name": "@@allow", "args": [{ "value": "update,delete" }] }, { "name": "@@map", "args": [{ "value": "users" }] }, { "name": "@@auth", "args": [] }],
        },
        account: {
            name: 'Account', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, type: {
                    name: "type",
                    type: "String",
                }, provider: {
                    name: "provider",
                    type: "String",
                }, providerAccountId: {
                    name: "providerAccountId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "provider_account_id" }] }],
                }, refresh_token: {
                    name: "refresh_token",
                    type: "String",
                    isOptional: true,
                }, access_token: {
                    name: "access_token",
                    type: "String",
                    isOptional: true,
                }, expires_at: {
                    name: "expires_at",
                    type: "Int",
                    isOptional: true,
                }, token_type: {
                    name: "token_type",
                    type: "String",
                    isOptional: true,
                }, scope: {
                    name: "scope",
                    type: "String",
                    isOptional: true,
                }, id_token: {
                    name: "id_token",
                    type: "String",
                    isOptional: true,
                }, session_state: {
                    name: "session_state",
                    type: "String",
                    isOptional: true,
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'accounts',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, provider_providerAccountId: {
                    name: "provider_providerAccountId",
                    fields: ["provider", "providerAccountId"]
                },
            },
            attributes: [{ "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "accounts" }] }],
        },
        session: {
            name: 'Session', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, sessionToken: {
                    name: "sessionToken",
                    type: "String",
                    attributes: [{ "name": "@unique", "args": [] }, { "name": "@map", "args": [{ "value": "session_token" }] }],
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'sessions',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, expires: {
                    name: "expires",
                    type: "DateTime",
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, sessionToken: {
                    name: "sessionToken",
                    fields: ["sessionToken"]
                },
            },
            attributes: [{ "name": "@@map", "args": [{ "value": "sessions" }] }],
        },
        verificationToken: {
            name: 'VerificationToken', fields: {
                identifier: {
                    name: "identifier",
                    type: "String",
                    isId: true,
                }, token: {
                    name: "token",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@unique", "args": [] }],
                }, expires: {
                    name: "expires",
                    type: "DateTime",
                },
            },
            uniqueConstraints: {
                identifier_token: {
                    name: "identifier_token",
                    fields: ["identifier", "token"]
                }, token: {
                    name: "token",
                    fields: ["token"]
                },
            },
            attributes: [{ "name": "@@id", "args": [] }, { "name": "@@map", "args": [{ "value": "verification_tokens" }] }],
        },
        place: {
            name: 'Place', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, googlePlaceId: {
                    name: "googlePlaceId",
                    type: "String",
                    attributes: [{ "name": "@unique", "args": [] }, { "name": "@map", "args": [{ "value": "google_place_id" }] }],
                }, name: {
                    name: "name",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "name" }] }],
                }, description: {
                    name: "description",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "description" }] }],
                }, types: {
                    name: "types",
                    type: "String",
                    isArray: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "types" }] }, { "name": "@default", "args": [] }],
                }, lat: {
                    name: "lat",
                    type: "Float",
                }, lng: {
                    name: "lng",
                    type: "Float",
                }, spots: {
                    name: "spots",
                    type: "Spot",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'place',
                }, imagesCachedAt: {
                    name: "imagesCachedAt",
                    type: "DateTime",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "images_cached_at" }] }],
                }, googleImages: {
                    name: "googleImages",
                    type: "GoogleImage",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'place',
                }, affiliates: {
                    name: "affiliates",
                    type: "PlaceAffiliate",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'place',
                }, inquiries: {
                    name: "inquiries",
                    type: "Inquiry",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'place',
                }, tripItems: {
                    name: "tripItems",
                    type: "TripItem",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'place',
                }, locationImageUrl: {
                    name: "locationImageUrl",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "location_image_url" }] }],
                }, formattedAddress: {
                    name: "formattedAddress",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "formatted_address" }] }],
                }, addressComponents: {
                    name: "addressComponents",
                    type: "Json",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "address_components" }] }],
                }, popularPlace: {
                    name: "popularPlace",
                    type: "Boolean",
                    attributes: [{ "name": "@default", "args": [{ "value": false }] }, { "name": "@map", "args": [{ "value": "popular_place" }] }],
                }, userSaves: {
                    name: "userSaves",
                    type: "UserPlaceSave",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'place',
                }, experiences: {
                    name: "experiences",
                    type: "ExperiencePlace",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'place',
                }, stayPlaces: {
                    name: "stayPlaces",
                    type: "TripDay",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'stayPlace',
                }, saves: {
                    name: "saves",
                    type: "Save",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'place',
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, googlePlaceId: {
                    name: "googlePlaceId",
                    fields: ["googlePlaceId"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@map", "args": [{ "value": "places" }] }],
        },
        placeAffiliate: {
            name: 'PlaceAffiliate', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, placeId: {
                    name: "placeId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "place_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'place',
                }, place: {
                    name: "place",
                    type: "Place",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'affiliates',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "placeId" },
                }, position: {
                    name: "position",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "position" }] }],
                }, type: {
                    name: "type",
                    type: "AffiliateType",
                    attributes: [{ "name": "@map", "args": [{ "value": "type" }] }],
                }, url: {
                    name: "url",
                    type: "String",
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, placeId_position: {
                    name: "placeId_position",
                    fields: ["placeId", "position"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "place_affiliates" }] }],
        },
        googleImage: {
            name: 'GoogleImage', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, photoReference: {
                    name: "photoReference",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "photo_reference" }] }],
                }, htmlAttributions: {
                    name: "htmlAttributions",
                    type: "String",
                    isArray: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "html_attributions" }] }],
                }, objectId: {
                    name: "objectId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "object_id" }] }],
                }, cachedUrl: {
                    name: "cachedUrl",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "cached_url" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                }, placeId: {
                    name: "placeId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "place_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'place',
                }, place: {
                    name: "place",
                    type: "Place",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'googleImages',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "placeId" },
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@map", "args": [{ "value": "google_images" }] }],
        },
        list: {
            name: 'List', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, name: {
                    name: "name",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "name" }] }],
                }, normalizedName: {
                    name: "normalizedName",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "normalized_name" }] }],
                }, slug: {
                    name: "slug",
                    type: "String",
                    attributes: [{ "name": "@unique", "args": [] }],
                }, description: {
                    name: "description",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "description" }] }],
                }, spots: {
                    name: "spots",
                    type: "Spot",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'list',
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'lists',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, visibility: {
                    name: "visibility",
                    type: "Visibility",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "visibility" }] }],
                }, collaborationKey: {
                    name: "collaborationKey",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@unique", "args": [] }, { "name": "@map", "args": [{ "value": "collaboration_key" }] }],
                }, sharingKey: {
                    name: "sharingKey",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@unique", "args": [] }, { "name": "@map", "args": [{ "value": "sharing_key" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                }, sharedUsers: {
                    name: "sharedUsers",
                    type: "SharedUsersOnLists",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'list',
                }, followers: {
                    name: "followers",
                    type: "FollowersOnLists",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'list',
                }, collaborators: {
                    name: "collaborators",
                    type: "CollaboratorsOnLists",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'list',
                }, photos: {
                    name: "photos",
                    type: "String",
                    isArray: true,
                }, tags: {
                    name: "tags",
                    type: "ListTag",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'list',
                }, priority: {
                    name: "priority",
                    type: "Int",
                    attributes: [{ "name": "@default", "args": [{ "value": 2 }] }, { "name": "@map", "args": [{ "value": "priority" }] }],
                }, saves: {
                    name: "saves",
                    type: "Save",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'list',
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, slug: {
                    name: "slug",
                    fields: ["slug"]
                }, collaborationKey: {
                    name: "collaborationKey",
                    fields: ["collaborationKey"]
                }, sharingKey: {
                    name: "sharingKey",
                    fields: ["sharingKey"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@map", "args": [{ "value": "lists" }] }],
        },
        listTag: {
            name: 'ListTag', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, list: {
                    name: "list",
                    type: "List",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'tags',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "listId" },
                }, listId: {
                    name: "listId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "list_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'list',
                }, tag: {
                    name: "tag",
                    type: "Tag",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'lists',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "tagId" },
                }, tagId: {
                    name: "tagId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "tag_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'tag',
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, listId_tagId: {
                    name: "listId_tagId",
                    fields: ["listId", "tagId"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "list_tags" }] }],
        },
        tag: {
            name: 'Tag', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, name: {
                    name: "name",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "name" }] }],
                }, slug: {
                    name: "slug",
                    type: "String",
                    attributes: [{ "name": "@unique", "args": [] }],
                }, title: {
                    name: "title",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "value": "" }] }, { "name": "@map", "args": [{ "value": "title" }] }],
                }, description: {
                    name: "description",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "value": "" }] }, { "name": "@map", "args": [{ "value": "description" }] }],
                }, position: {
                    name: "position",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "position" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                }, lists: {
                    name: "lists",
                    type: "ListTag",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'tag',
                }, spots: {
                    name: "spots",
                    type: "SpotTag",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'tag',
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, slug: {
                    name: "slug",
                    fields: ["slug"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@map", "args": [{ "value": "tags" }] }],
        },
        sharedUsersOnLists: {
            name: 'SharedUsersOnLists', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, list: {
                    name: "list",
                    type: "List",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'sharedUsers',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "listId" },
                }, listId: {
                    name: "listId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "list_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'list',
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'sharedLists',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, userId_listId: {
                    name: "userId_listId",
                    fields: ["userId", "listId"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "list_shared_users" }] }],
        },
        followersOnLists: {
            name: 'FollowersOnLists', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'followingLists',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, list: {
                    name: "list",
                    type: "List",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'followers',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "listId" },
                }, listId: {
                    name: "listId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "list_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'list',
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, userId_listId: {
                    name: "userId_listId",
                    fields: ["userId", "listId"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "user_following_lists" }] }],
        },
        collaboratorsOnLists: {
            name: 'CollaboratorsOnLists', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, list: {
                    name: "list",
                    type: "List",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'collaborators',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "listId" },
                }, listId: {
                    name: "listId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "list_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'list',
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'collaboratingLists',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, userId_listId: {
                    name: "userId_listId",
                    fields: ["userId", "listId"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "list_collaborators" }] }],
        },
        spot: {
            name: 'Spot', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, list: {
                    name: "list",
                    type: "List",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'spots',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "listId" },
                }, listId: {
                    name: "listId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "list_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'list',
                }, place: {
                    name: "place",
                    type: "Place",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'spots',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "placeId" },
                }, placeId: {
                    name: "placeId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "place_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'place',
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'spots',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, name: {
                    name: "name",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "name" }] }],
                }, normalizedName: {
                    name: "normalizedName",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "normalized_name" }] }],
                }, slug: {
                    name: "slug",
                    type: "String",
                    attributes: [{ "name": "@unique", "args": [] }],
                }, comment: {
                    name: "comment",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "comment" }] }],
                }, position: {
                    name: "position",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "position" }] }],
                }, userVisits: {
                    name: "userVisits",
                    type: "UserSpotVisit",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'spot',
                }, userFavs: {
                    name: "userFavs",
                    type: "UserSpotFav",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'spot',
                }, inqueries: {
                    name: "inqueries",
                    type: "Inquiry",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'spot',
                }, tags: {
                    name: "tags",
                    type: "SpotTag",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'spot',
                }, priority: {
                    name: "priority",
                    type: "Int",
                    attributes: [{ "name": "@default", "args": [{ "value": 2 }] }, { "name": "@map", "args": [{ "value": "priority" }] }],
                }, tripItems: {
                    name: "tripItems",
                    type: "TripItem",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'spot',
                }, images: {
                    name: "images",
                    type: "SpotImage",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'spot',
                }, saves: {
                    name: "saves",
                    type: "Save",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'spot',
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, slug: {
                    name: "slug",
                    fields: ["slug"]
                }, listId_position: {
                    name: "listId_position",
                    fields: ["listId", "position"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "create,read" }, { "value": true }] }, { "name": "@@allow", "args": [{ "value": "update,delete" }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "spots" }] }],
        },
        spotImage: {
            name: 'SpotImage', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, objectId: {
                    name: "objectId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "object_id" }] }],
                }, cachedUrl: {
                    name: "cachedUrl",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "cached_url" }] }],
                }, spotId: {
                    name: "spotId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "spot_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'spot',
                }, spot: {
                    name: "spot",
                    type: "Spot",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'images',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "spotId" },
                }, position: {
                    name: "position",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "position" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, spotId_position: {
                    name: "spotId_position",
                    fields: ["spotId", "position"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "create,read" }, { "value": true }] }, { "name": "@@allow", "args": [{ "value": "update,delete" }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "spot_images" }] }],
        },
        spotTag: {
            name: 'SpotTag', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, spot: {
                    name: "spot",
                    type: "Spot",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'tags',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "spotId" },
                }, spotId: {
                    name: "spotId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "spot_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'spot',
                }, tag: {
                    name: "tag",
                    type: "Tag",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'spots',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "tagId" },
                }, tagId: {
                    name: "tagId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "tag_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'tag',
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, spotId_tagId: {
                    name: "spotId_tagId",
                    fields: ["spotId", "tagId"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "spot_tags" }] }],
        },
        userSpotVisit: {
            name: 'UserSpotVisit', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'visitedSpots',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, spot: {
                    name: "spot",
                    type: "Spot",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'userVisits',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "spotId" },
                }, spotId: {
                    name: "spotId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "spot_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'spot',
                }, comment: {
                    name: "comment",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "comment" }] }],
                }, visitedAt: {
                    name: "visitedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@map", "args": [{ "value": "visited_at" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, userId_spotId: {
                    name: "userId_spotId",
                    fields: ["userId", "spotId"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "create" }, { "value": true }] }, { "name": "@@allow", "args": [{ "value": "read,update,delete" }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "user_spot_visits" }] }],
        },
        userSpotFav: {
            name: 'UserSpotFav', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'favedSpots',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, spot: {
                    name: "spot",
                    type: "Spot",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'userFavs',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "spotId" },
                }, spotId: {
                    name: "spotId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "spot_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'spot',
                }, favedAt: {
                    name: "favedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@map", "args": [{ "value": "faved_at" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, userId_spotId: {
                    name: "userId_spotId",
                    fields: ["userId", "spotId"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "create,read" }, { "value": true }] }, { "name": "@@allow", "args": [{ "value": "update,delete" }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "user_spot_favs" }] }],
        },
        userPlaceSave: {
            name: 'UserPlaceSave', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'savedPlaces',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, place: {
                    name: "place",
                    type: "Place",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'userSaves',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "placeId" },
                }, placeId: {
                    name: "placeId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "place_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'place',
                }, savedAt: {
                    name: "savedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@map", "args": [{ "value": "saved_at" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, userId_placeId: {
                    name: "userId_placeId",
                    fields: ["userId", "placeId"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "create,read" }, { "value": true }] }, { "name": "@@allow", "args": [{ "value": "update,delete" }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "user_place_saves" }] }],
        },
        trip: {
            name: 'Trip', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'trips',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, name: {
                    name: "name",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "name" }] }],
                }, description: {
                    name: "description",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "description" }] }],
                }, startDate: {
                    name: "startDate",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "start_date" }] }],
                }, days: {
                    name: "days",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "days" }] }],
                }, tripDays: {
                    name: "tripDays",
                    type: "TripDay",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'trip',
                }, popularPlanId: {
                    name: "popularPlanId",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "popular_plan_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'popularPlan',
                }, popularPlan: {
                    name: "popularPlan",
                    type: "PopularPlan",
                    isDataModel: true,
                    isOptional: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'trips',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "popularPlanId" },
                }, desiredDestinations: {
                    name: "desiredDestinations",
                    type: "String",
                    isArray: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "desired_destinations" }] }, { "name": "@default", "args": [] }],
                }, withWhom: {
                    name: "withWhom",
                    type: "String",
                    isArray: true,
                    attributes: [{ "name": "@default", "args": [] }],
                }, conditions: {
                    name: "conditions",
                    type: "String",
                    isArray: true,
                    attributes: [{ "name": "@default", "args": [] }],
                }, ideaText: {
                    name: "ideaText",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "idea_text" }] }],
                }, entryPlace: {
                    name: "entryPlace",
                    type: "String",
                    isOptional: true,
                }, exitPlace: {
                    name: "exitPlace",
                    type: "String",
                    isOptional: true,
                }, aiInCreating: {
                    name: "aiInCreating",
                    type: "Boolean",
                    attributes: [{ "name": "@map", "args": [{ "value": "ai_in_creating" }] }, { "name": "@default", "args": [{ "value": false }] }],
                }, archivedAt: {
                    name: "archivedAt",
                    type: "DateTime",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "archived_at" }] }],
                }, bookingExperriences: {
                    name: "bookingExperriences",
                    type: "BookingExperience",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'trip',
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@map", "args": [{ "value": "trips" }] }],
        },
        tripDay: {
            name: 'TripDay', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, trip: {
                    name: "trip",
                    type: "Trip",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'tripDays',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "tripId" },
                }, tripId: {
                    name: "tripId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "trip_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'trip',
                }, nthDay: {
                    name: "nthDay",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "nth_day" }] }],
                }, title: {
                    name: "title",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "title" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                }, items: {
                    name: "items",
                    type: "TripItem",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'tripDay',
                }, aiSuggestedPlans: {
                    name: "aiSuggestedPlans",
                    type: "String",
                    isArray: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "ai_suggested_plans" }] }],
                }, aiSuggestedPlaces: {
                    name: "aiSuggestedPlaces",
                    type: "Json",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "ai_suggested_places" }] }],
                }, transportation: {
                    name: "transportation",
                    type: "String",
                    isOptional: true,
                }, stayPlace: {
                    name: "stayPlace",
                    type: "Place",
                    isDataModel: true,
                    isOptional: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'stayPlaces',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "stayPlaceId" },
                }, stayPlaceId: {
                    name: "stayPlaceId",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "stay_place_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'stayPlace',
                }, accommodationPlace: {
                    name: "accommodationPlace",
                    type: "String",
                    isOptional: true,
                }, region: {
                    name: "region",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "region" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, tripId_nthDay: {
                    name: "tripId_nthDay",
                    fields: ["tripId", "nthDay"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "trip_days" }] }],
        },
        tripItem: {
            name: 'TripItem', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, tripDay: {
                    name: "tripDay",
                    type: "TripDay",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'items',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "tripDayId" },
                }, tripDayId: {
                    name: "tripDayId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "trip_day_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'tripDay',
                }, position: {
                    name: "position",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "position" }] }],
                }, type: {
                    name: "type",
                    type: "TripItemType",
                    attributes: [{ "name": "@map", "args": [{ "value": "type" }] }],
                }, title: {
                    name: "title",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "title" }] }, { "name": "@default", "args": [{ "value": "" }] }],
                }, spot: {
                    name: "spot",
                    type: "Spot",
                    isDataModel: true,
                    isOptional: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'tripItems',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "spotId" },
                }, spotId: {
                    name: "spotId",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "spot_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'spot',
                }, note: {
                    name: "note",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "note" }] }],
                }, place: {
                    name: "place",
                    type: "Place",
                    isDataModel: true,
                    isOptional: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'tripItems',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "placeId" },
                }, placeId: {
                    name: "placeId",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "place_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'place',
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, tripDayId_position: {
                    name: "tripDayId_position",
                    fields: ["tripDayId", "position"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "trip_items" }] }],
        },
        popularPlan: {
            name: 'PopularPlan', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, title: {
                    name: "title",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "title" }] }],
                }, position: {
                    name: "position",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "position" }] }],
                }, description: {
                    name: "description",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "description" }] }],
                }, places: {
                    name: "places",
                    type: "String",
                    isArray: true,
                    attributes: [{ "name": "@default", "args": [] }],
                }, note: {
                    name: "note",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "note" }] }],
                }, trips: {
                    name: "trips",
                    type: "Trip",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'popularPlan',
                }, suggestedMinimumDays: {
                    name: "suggestedMinimumDays",
                    type: "Int",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "suggested_minimum_days" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@map", "args": [{ "value": "popular_plans" }] }],
        },
        inquiry: {
            name: 'Inquiry', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'inquiries',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, place: {
                    name: "place",
                    type: "Place",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'inquiries',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "placeId" },
                }, placeId: {
                    name: "placeId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "place_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'place',
                }, spot: {
                    name: "spot",
                    type: "Spot",
                    isDataModel: true,
                    isOptional: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'inqueries',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "spotId" },
                }, spotId: {
                    name: "spotId",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "spot_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'spot',
                }, text: {
                    name: "text",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "text" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@map", "args": [{ "value": "inquiries" }] }],
        },
        experience: {
            name: 'Experience', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, position: {
                    name: "position",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "position" }] }],
                }, type: {
                    name: "type",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "type" }] }],
                }, title: {
                    name: "title",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "title" }] }],
                }, shortBlub: {
                    name: "shortBlub",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "short_blub" }] }],
                }, description: {
                    name: "description",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "description" }] }],
                }, duration: {
                    name: "duration",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "duration" }] }],
                }, cancellationPolicy: {
                    name: "cancellationPolicy",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "cancel_policy" }] }],
                }, guideLanguages: {
                    name: "guideLanguages",
                    type: "String",
                    isArray: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "guide_languages" }] }, { "name": "@default", "args": [] }],
                }, meetingPointLat: {
                    name: "meetingPointLat",
                    type: "Float",
                    attributes: [{ "name": "@map", "args": [{ "value": "meeting_point_lat" }] }],
                }, meetingPointLng: {
                    name: "meetingPointLng",
                    type: "Float",
                    attributes: [{ "name": "@map", "args": [{ "value": "meeting_point_lng" }] }],
                }, meetingPointAltText: {
                    name: "meetingPointAltText",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "meeting_point_alt_text" }] }],
                }, includes: {
                    name: "includes",
                    type: "String",
                    isArray: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "includes" }] }, { "name": "@default", "args": [] }],
                }, excludes: {
                    name: "excludes",
                    type: "String",
                    isArray: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "excludes" }] }, { "name": "@default", "args": [] }],
                }, notAllowed: {
                    name: "notAllowed",
                    type: "String",
                    isArray: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "not_allowed" }] }, { "name": "@default", "args": [] }],
                }, knowBeforeYouGo: {
                    name: "knowBeforeYouGo",
                    type: "String",
                    isArray: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "know_before_you_go" }] }, { "name": "@default", "args": [] }],
                }, places: {
                    name: "places",
                    type: "ExperiencePlace",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'experience',
                }, priceAdult: {
                    name: "priceAdult",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "price_adult" }] }, { "name": "@default", "args": [{ "value": 0 }] }],
                }, priceChild: {
                    name: "priceChild",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "price_child" }] }, { "name": "@default", "args": [{ "value": 0 }] }],
                }, priceInfant: {
                    name: "priceInfant",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "price_infant" }] }, { "name": "@default", "args": [{ "value": 0 }] }],
                }, stars: {
                    name: "stars",
                    type: "Float",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "stars" }] }],
                }, reviewsCount: {
                    name: "reviewsCount",
                    type: "Int",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "reviews_count" }] }],
                }, bookingExperiences: {
                    name: "bookingExperiences",
                    type: "BookingExperience",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'experience',
                }, images: {
                    name: "images",
                    type: "ExperienceImage",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'experience',
                }, saves: {
                    name: "saves",
                    type: "Save",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'experience',
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@map", "args": [{ "value": "experiences" }] }],
        },
        experienceImage: {
            name: 'ExperienceImage', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, objectId: {
                    name: "objectId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "object_id" }] }],
                }, cachedUrl: {
                    name: "cachedUrl",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "cached_url" }] }],
                }, experience: {
                    name: "experience",
                    type: "Experience",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'images',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "experienceId" },
                }, experienceId: {
                    name: "experienceId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "experience_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'experience',
                }, position: {
                    name: "position",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "position" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, experienceId_position: {
                    name: "experienceId_position",
                    fields: ["experienceId", "position"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "experience_images" }] }],
        },
        experiencePlace: {
            name: 'ExperiencePlace', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, experience: {
                    name: "experience",
                    type: "Experience",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'places',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "experienceId" },
                }, experienceId: {
                    name: "experienceId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "experience_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'experience',
                }, place: {
                    name: "place",
                    type: "Place",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'experiences',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "placeId" },
                }, placeId: {
                    name: "placeId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "place_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'place',
                }, position: {
                    name: "position",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "position" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, experienceId_placeId: {
                    name: "experienceId_placeId",
                    fields: ["experienceId", "placeId"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@unique", "args": [] }, { "name": "@@map", "args": [{ "value": "experience_places" }] }],
        },
        bookingExperience: {
            name: 'BookingExperience', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'bookingExperiences',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, experience: {
                    name: "experience",
                    type: "Experience",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'bookingExperiences',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "experienceId" },
                }, experienceId: {
                    name: "experienceId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "experience_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'experience',
                }, date: {
                    name: "date",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "date" }] }],
                }, tripId: {
                    name: "tripId",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "trip_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'trip',
                }, trip: {
                    name: "trip",
                    type: "Trip",
                    isDataModel: true,
                    isOptional: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'bookingExperriences',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "tripId" },
                }, numberOfAdults: {
                    name: "numberOfAdults",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "number_of_adults" }] }],
                }, numberOfChildren: {
                    name: "numberOfChildren",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "number_of_children" }] }],
                }, numberOfInfants: {
                    name: "numberOfInfants",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "number_of_infants" }] }],
                }, unitAdultsPrice: {
                    name: "unitAdultsPrice",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "unit_price_adult" }] }],
                }, unitChildrenPrice: {
                    name: "unitChildrenPrice",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "unit_price_child" }] }],
                }, unitInfantsPrice: {
                    name: "unitInfantsPrice",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "unit_price_infant" }] }],
                }, totalAdultsPrice: {
                    name: "totalAdultsPrice",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "price_adult" }] }],
                }, totalChildrenPrice: {
                    name: "totalChildrenPrice",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "price_child" }] }],
                }, totalInfantsPrice: {
                    name: "totalInfantsPrice",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "price_infant" }] }],
                }, totalPrice: {
                    name: "totalPrice",
                    type: "Int",
                    attributes: [{ "name": "@map", "args": [{ "value": "total_price" }] }],
                }, status: {
                    name: "status",
                    type: "ExperiencePaymentStatus",
                    attributes: [{ "name": "@map", "args": [{ "value": "status" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
            attributes: [{ "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@map", "args": [{ "value": "booking_experiences" }] }],
        },
        save: {
            name: 'Save', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@id", "args": [] }, { "name": "@default", "args": [] }, { "name": "@db.Uuid", "args": [] }],
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'saves',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ "name": "@map", "args": [{ "value": "user_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'user',
                }, type: {
                    name: "type",
                    type: "SaveType",
                }, place: {
                    name: "place",
                    type: "Place",
                    isDataModel: true,
                    isOptional: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'saves',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "placeId" },
                }, placeId: {
                    name: "placeId",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "place_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'place',
                }, spot: {
                    name: "spot",
                    type: "Spot",
                    isDataModel: true,
                    isOptional: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'saves',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "spotId" },
                }, spotId: {
                    name: "spotId",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "spot_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'spot',
                }, experience: {
                    name: "experience",
                    type: "Experience",
                    isDataModel: true,
                    isOptional: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'saves',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "experienceId" },
                }, experienceId: {
                    name: "experienceId",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "experience_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'experience',
                }, list: {
                    name: "list",
                    type: "List",
                    isDataModel: true,
                    isOptional: true,
                    attributes: [{ "name": "@relation", "args": [] }],
                    backLink: 'saves',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "listId" },
                }, listId: {
                    name: "listId",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@map", "args": [{ "value": "list_id" }] }, { "name": "@db.Uuid", "args": [] }],
                    isForeignKey: true,
                    relationField: 'list',
                }, savedAt: {
                    name: "savedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@map", "args": [{ "value": "saved_at" }] }],
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@map", "args": [{ "value": "created_at" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [] }, { "name": "@updatedAt", "args": [] }, { "name": "@map", "args": [{ "value": "updated_at" }] }],
                },
            },
            uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, userId_type_placeId: {
                    name: "userId_type_placeId",
                    fields: ["userId", "type", "placeId"]
                }, userId_type_spotId: {
                    name: "userId_type_spotId",
                    fields: ["userId", "type", "spotId"]
                }, userId_type_experienceId: {
                    name: "userId_type_experienceId",
                    fields: ["userId", "type", "experienceId"]
                }, userId_type_listId: {
                    name: "userId_type_listId",
                    fields: ["userId", "type", "listId"]
                },
            },
            attributes: [{ "name": "@@unique", "args": [] }, { "name": "@@unique", "args": [] }, { "name": "@@unique", "args": [] }, { "name": "@@unique", "args": [] }, { "name": "@@allow", "args": [{ "value": "all" }, { "value": true }] }, { "name": "@@map", "args": [{ "value": "saves" }] }],
        },
    },
    deleteCascade: {
        user: ['Account', 'Session'],
        place: ['PlaceAffiliate', 'GoogleImage', 'UserPlaceSave'],
        list: ['ListTag', 'SharedUsersOnLists', 'FollowersOnLists', 'CollaboratorsOnLists'],
        tag: ['ListTag', 'SpotTag'],
        spot: ['SpotImage', 'SpotTag', 'UserSpotVisit', 'UserSpotFav'],
        trip: ['TripDay'],
        tripDay: ['TripItem'],
        experience: ['ExperienceImage'],
    },
    authModel: 'User'
};
exports.default = metadata;
